module.exports = __webpack_public_path__ + "img/17semaphore.e5700264.png";